export const ARoles = [
    { value: 'individual', label: 'Fyzická osoba' },
    { value: 'legal', label: 'Právnická osoba' },
    { value: 'trust', label: 'Společní účastníci' },
    { value: 'admin', label: 'Administrátor' },
];
export const getRoleLabel = (value) => {
    let res = ARoles.filter(obj => obj.value == value)[0];
    return res ? res.label : 'N/A';
};
